export const bits32 = str => (str >> 0) == str // eslint-disable-line eqeqeq
